import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SubTitleBar from "../../components/SubTitleBar/SubTitleBar";
import StateAdminList from "../StateDOTAdmin/StateAdminManagement/StateAdminList/component";
import { checkIsSuperAdmin } from "../../helpers/utils";
import OrganizationsList from "./OrganizationsList/OrganizationsList";
import _ from "lodash";

export default function SuperAdminHome() {
  const history = useHistory();
  const location = useLocation();
  const initialViewState = location?.pathname.includes(
    "/super-admin-membership-portal"
  );

  const [isStateView, setStateView] = useState(initialViewState);

  const fromStateAdminManagement = location?.state?.stateAdmin || false;

  const isMembershipPortal = useMemo(
    () => location?.pathname.includes("/super-admin-membership-portal"),
    [location?.pathname]
  );

  useEffect(() => {
    setStateView(isMembershipPortal);
  }, [isMembershipPortal]);

  const handleBackBtnClick = () => {
    history.push({
      pathname: "/super-admin-membership-portal",
    });
  };

  return (
    <main>
      <SubTitleBar
        showBackBtn={fromStateAdminManagement}
        onBackBtnClick={handleBackBtnClick}
        showActions={checkIsSuperAdmin() && !fromStateAdminManagement}
        onActionClick={() =>
          isStateView
            ? history.push("/super-admin")
            : history.push("/super-admin-membership-portal")
        }
        actionsLabel={
          isStateView ? "Organization Management" : "Membership Portal"
        }
      >
        {!isStateView
          ? `Organization Management${
              fromStateAdminManagement
                ? ` - ${fromStateAdminManagement?.name}`
                : ""
            }`
          : " Membership Portal"}
      </SubTitleBar>

      {isStateView ? (
        <div className="state-dot-admin-list-container">
          <StateAdminList />
        </div>
      ) : (
        <OrganizationsList />
      )}
    </main>
  );
}
